/**
 * SectionCard をドラッグ&ドロップ可能にするラッパー。
 * 仕様書: docs/01_spec/spec_mail_system.md B-15 (Phase 22b)
 *
 * @dnd-kit/sortable の useSortable を利用。
 * カード左端に grip ハンドルを配置し、そこをつかんで並べ替え。
 */
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import type { ComponentProps } from 'react';

import { SectionCard } from './SectionCard';

type SectionCardProps = ComponentProps<typeof SectionCard>;

export function SortableSection(props: SectionCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.section.id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    zIndex: isDragging ? 50 : undefined,
    position: 'relative',
  };

  return (
    <div ref={setNodeRef} style={style} className="group">
      <button
        ref={setActivatorNodeRef}
        type="button"
        {...attributes}
        {...listeners}
        className="absolute -left-6 top-2 size-6 flex items-center justify-center text-[var(--text-muted)] hover:text-[var(--accent)] cursor-grab active:cursor-grabbing opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity"
        title="ドラッグして並べ替え"
        aria-label="セクションを並べ替え"
      >
        <GripVertical className="size-4" />
      </button>
      <SectionCard {...props} />
    </div>
  );
}
